import QuoteHeaderBa from './ba/quotes/header';
import QuoteHeaderBg from './bg/quotes/header';
import QuoteHeaderCn from './cn/quotes/header';
import QuoteHeaderTw from './tw/quotes/header';
import QuoteHeaderDe from './de/quotes/header';
import QuoteHeaderDk from './dk/quotes/header';
import QuoteHeaderEn from './en/quotes/header';
import QuoteHeaderEs from './es/quotes/header';
import QuoteHeaderFi from './fi/quotes/header';
import QuoteHeaderFr from './fr/quotes/header';
import QuoteHeaderHr from './hr/quotes/header';
import QuoteHeaderHu from './hu/quotes/header';
import QuoteHeaderGr from './gr/quotes/header';
import QuoteHeaderIt from './it/quotes/header';
import QuoteHeaderJp from './jp/quotes/header';
import QuoteHeaderLt from './lt/quotes/header';
import QuoteHeaderLv from './lv/quotes/header';
import QuoteHeaderMe from './me/quotes/header';
import QuoteHeaderMk from './mk/quotes/header';
import QuoteHeaderMt from './mt/quotes/header';
import QuoteHeaderNl from './nl/quotes/header';
import QuoteHeaderPl from './pl/quotes/header';
import QuoteHeaderPt from './pt/quotes/header';
import QuoteHeaderRs from './rs/quotes/header';
import QuoteHeaderSe from './se/quotes/header';
import QuoteHeaderTr from './tr/quotes/header';
import QuoteHeaderUs from './en-us/quotes/header';

export default {
    messages: {
        ba: { QuoteHeader: QuoteHeaderBa },
        bg: { QuoteHeader: QuoteHeaderBg },
        cn: { QuoteHeader: QuoteHeaderCn },
        tw: { QuoteHeader: QuoteHeaderTw },
        de: { QuoteHeader: QuoteHeaderDe },
        dk: { QuoteHeader: QuoteHeaderDk },
        en: { QuoteHeader: QuoteHeaderEn },
        'en-us': { QuoteHeader: QuoteHeaderUs },
        es: { QuoteHeader: QuoteHeaderEs },
        fi: { QuoteHeader: QuoteHeaderFi },
        fr: { QuoteHeader: QuoteHeaderFr },
        hr: { QuoteHeader: QuoteHeaderHr },
        hu: { QuoteHeader: QuoteHeaderHu },
        gr: { QuoteHeader: QuoteHeaderGr },
        it: { QuoteHeader: QuoteHeaderIt },
        jp: { QuoteHeader: QuoteHeaderJp },
        lt: { QuoteHeader: QuoteHeaderLt },
        lv: { QuoteHeader: QuoteHeaderLv },
        me: { QuoteHeader: QuoteHeaderMe },
        mk: { QuoteHeader: QuoteHeaderMk },
        mt: { QuoteHeader: QuoteHeaderMt },
        mx: { QuoteHeader: QuoteHeaderEs },
        nl: { QuoteHeader: QuoteHeaderNl },
        pl: { QuoteHeader: QuoteHeaderPl },
        pt: { QuoteHeader: QuoteHeaderPt },
        rs: { QuoteHeader: QuoteHeaderRs },
        se: { QuoteHeader: QuoteHeaderSe },
        tr: { QuoteHeader: QuoteHeaderTr },
    },
};
